import { Outlet } from 'react-router-dom'
import { clsx } from 'clsx'
import { useResponsive } from '@/contexts/ResponsiveContext'
import Sidebar from '@/components/layouts/Sidebar'
import Header from '@/components/layouts/Header'

const DashboardLayout = () => {
  const { 
    isMobile, 
    isDesktop, 
    getContainerPadding,
    sidebarOpen,
    setSidebarOpen
  } = useResponsive()

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content wrapper */}
      <div className={clsx(
        'flex flex-col min-h-screen transition-all duration-300',
        // Adjust margin for fixed desktop sidebar
        isDesktop && 'ml-64'
      )}>
        {/* Header */}
        <Header onMenuClick={() => setSidebarOpen(true)} />

        {/* Main content area */}
        <main className="flex-1 overflow-y-auto">
          <div className={clsx(
            'py-6',
            getContainerPadding()
          )}>
            <div className="max-w-7xl mx-auto">
              <Outlet />
            </div>
          </div>
        </main>
      </div>

      {/* Mobile overlay backdrop */}
      {isMobile && sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-[1030]"
          onClick={(event) => {
            event.stopPropagation()
            setSidebarOpen(false)
          }}
        />
      )}
    </div>
  )
}

export default DashboardLayout